import './logRocket';
import React from 'react';
import { createRoot } from 'react-dom/client';
// Base datepicker styles; src/_datepicker.scss themes on top of these
import 'react-datepicker/dist/react-datepicker.css';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { cleanupDeprecatedKeys } from './services/auth.bootstrap';

import moment from 'moment';
import 'moment/locale/es';

moment.locale('es')

// Drop any leftover legacy storage entry; the session lives in the fp_prof_profileid cookie.
cleanupDeprecatedKeys();

// No StrictMode: @apollo/react-hooks 3.x cannot survive its double mount/unmount,
// the query subscription is torn down and never re-established (stuck loading).
const root = createRoot(document.getElementById('root'));
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
